export default __webpack_public_path__ + "static/media/instant-quotaition-icon.b8d7cf18.svg";